import React from "react"
import ContainerStyles from "../styles/container.module.scss"
export default function Container({ children, ...args }) {
  return (
    <div className="relative w-full max-w-screen-xl px-5 xl:mx-auto md:px-10 xxl:px-0">
      {children}
    </div>
  )
}
